export default "__VITE_ASSET__DYs$vtqN__"